<template>
  <nav-menu
    name="Occasions"
    title="Greeting cards for any occasion"
    subtitle="Add your own text, pictures, videos, and more"
    action="View all cards"
    :icon="mdiCards"
    :to="{ name: 'catalog' }"
    v-bind="$attrs" v-on="$listeners"
  >
    <v-row class="ma-0">
      <v-col cols="6">
        <div v-if="specialCategories.priv.length" class="mb-3">
          <div class="caption">Private collections</div>
          <div v-for="[ name, icon, iconColor, textClass ] in specialCategories.priv" class="mx-n2">
            <v-btn text :to="{ name: 'catalog', query: { q: name } }">
              <v-icon small :color="iconColor" class="mr-1" v-html="icon" />
              <span :class="textClass">{{name | category}}</span>
            </v-btn>
          </div>
        </div>
        <div v-if="specialCategories.local.length" class="mb-3">
          <div class="caption">Special occasions</div>
          <div v-for="[ name, icon, iconColor, textClass ] in specialCategories.local" class="mx-n2">
            <v-btn text :to="{ name: 'catalog', query: { q: name } }">
              <v-icon small :color="iconColor" class="mr-1" v-html="icon" />
              <span :class="textClass" v-html="name" />
            </v-btn>
          </div>
        </div>
        <div v-for="[ name, icon ] in DEFAULT_CATEGORIES" class="mx-n2">
          <v-btn text color="primary" :to="{ name: 'catalog', query: { q: name } }">
            <v-icon small class="mr-1" v-html="icon" />{{name}}
          </v-btn>
        </div>
      </v-col>

      <v-col cols="6">
        <div class="caption">Search for anything</div>
        <v-text-field
          class="mt-2 mb-1 white"
          label="Search" v-model="searchText" outlined dense rounded hide-details multiple single-line clearable
          :append-icon="mdiMagnify"
          @click.capture.stop
          @click:append="search"
          @keydown.enter="search"
        />
        <div v-for="q in [ 'flowers', 'funny dogs', 'animated', 'happy animals', 'summer party' ]" class="mx-n2">
          <v-btn text color="primary" :to="{ name: 'catalog', query: { q: q.split(' ') } }">{{q}}</v-btn>
        </div>

        <div class="mt-6 caption">Design your own cards / invitations</div>
        <div
          v-for="[ name, icon, route ] in [
            [ 'Blank card', mdiPencilBoxOutline, { params: { designId: blankDesignId } } ],
            [ 'Templates', iconPathCollage, { query: { q: 'Template' } } ],
            [ 'Invitations', mdiCalendarMultipleCheck, { query: { q: 'Invitation' } } ]
          ]"
          class="mx-n2"
        >
          <v-btn text color="primary" :to="{ name: 'catalog', ...route }">
            <v-icon small color="primary" class="mr-1" v-html="icon" />{{name}}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </nav-menu>
</template>

<script>
import NavMenu from '@/components/NavMenu.vue';
import { blankDesignId } from '@/mixins/public-design.js';
import { DEFAULT_CATEGORIES } from '@/utils/categories.js';
import { COUNTRY_CODE } from '@/utils/intl.js';
import iconPathCollage from 'raw-loader!@/assets/icon-path-collage.txt';
import { mdiClose, mdiCards, mdiMagnify, mdiDramaMasks, mdiFlower, mdiDogSide, mdiBalloon, mdiPencilBoxOutline, mdiCalendarMultipleCheck } from '@mdi/js';

export default {
  name: 'nav-menu-occasions',

  components: {
    NavMenu
  },

  data() {
    return {
      searchText: ''
    };
  },

  computed: {
    specialCategories() {
      const [ priv, local ] = _.partition(this.global.localCategories, x => x[0].startsWith('['));
      return { priv, local };
    }
  },

  created() {
    Object.assign(this, { DEFAULT_CATEGORIES, blankDesignId, iconPathCollage, mdiClose, mdiCards, mdiMagnify, mdiDramaMasks, mdiFlower, mdiDogSide, mdiBalloon, mdiPencilBoxOutline, mdiCalendarMultipleCheck });
  },

  methods: {
    search() {
      // Note that this doesn't have the same handling as the category-search input that extracts categories (it should)
      const q = this.searchText.split(/\s+/);
      this.$router.push({ name: 'catalog', query: { q } });
      this.$emit('input', false);
    }
  }
}
</script>
